
import Vue from 'vue'
import RealTransformer from '@/transformers/workPlan/real'

export default (opts={}) => {
  let url = 'workplan/real/extranet/'
  const { residentId, id, finished, cancelToken, dateStart } = opts 

  if (id) {
    url += `${id}/`
  } else if ( residentId ) {
   url += `resident/${residentId}/`
  }

  const params = {
    finished: finished ? finished : undefined,
    date_start: dateStart || '2018-01-01'
  }

  return Vue.$http.get(url, { params, cancelToken })
    .then(response => {
      let data

      if (!id) {
        data = RealTransformer.fetchCollection(response.data)
          .sort((a, b) => a.startDate - b.startDate)
      } else {
        data = RealTransformer.fetch(response.data)
      }

      return data
    })
}



// WEBPACK FOOTER //
// ./src/services/customersExtranet/fetchReal.js